module.exports = __webpack_public_path__ + "img/vogue.eef3b32b.png";